'use strict';

goog.provide("Ntry.Grid");

goog.require("Ntry.STATIC");

Ntry.Grid = function(grid) {
    this.x = grid.x;
    this.y = grid.y
}

Ntry.Grid.prototype.type =
    Ntry.STATIC.GRID;
